import React from 'react'
import type { GetFeaturedVideosQuery } from 'apollo-gql'

import useRequestOccasions from 'hooks/useRequestOccasions'

import CardWrapper from '../CardWrapper/CardWrapper'
import OccasionCard from '../OccasionCard/OccasionCard'
import OccasionCardSkeleton from '../OccasionCardSkeleton/OccasionCardSkeleton'
import { FeaturedVideoProps, RequestOccasionProps } from '../type'

const occasionsWithoutVideo = (
  occasions: RequestOccasionProps[],
  videos: FeaturedVideoProps[],
): RequestOccasionProps[] => {
  const featuredVideosOccasions = new Set(
    videos
      .filter((video: FeaturedVideoProps) => video.requestOccasion)
      .map((video: FeaturedVideoProps) => video.requestOccasion.id),
  )

  return occasions.filter(
    (occasion: RequestOccasionProps) =>
      !featuredVideosOccasions.has(occasion.id),
  )
}

type OccasionsProps = {
  videos: GetFeaturedVideosQuery['market']['profile']['featuredVideos']
  profileName: string
  profileSlug: string
  occasionsToShow: number
}

const Occasions = ({
  videos,
  profileName,
  profileSlug,
  occasionsToShow = 0,
}: OccasionsProps): JSX.Element => {
  const { requestOccasions, loading, error } = useRequestOccasions({
    productType: 'VIDEO_REQUEST',
  })

  if (error) return null

  if (loading) return <OccasionCardSkeleton />

  return (
    <>
      {occasionsWithoutVideo(requestOccasions, videos)
        .slice(0, occasionsToShow)
        .map((requestOccasion) => (
          <CardWrapper key={`occasion-${requestOccasion.id}`}>
            <OccasionCard
              occasion={requestOccasion}
              profileName={profileName}
              profileSlug={profileSlug}
            />
          </CardWrapper>
        ))}
    </>
  )
}

export default Occasions
